export class Transportista{
    id: string;
    nombre: string;
    cuit: string;
    domicilio: string;
}